// ServiceNow Certifications Mapping - Full Name to Acronym
export const CERTIFICATION_ACRONYMS = {
  'Certified Application Developer': 'CAD',
  'Certified System Administrator': 'CSA',
  'Certified Platform Owner Associate': 'POA',
  'Certified Implementation Specialist - Application Portfolio Management': 'CIS-APM',
  'Certified Implementation Specialist - Cloud Provisioning and Governance': 'CIS-CPG',
  'Certified Implementation Specialist - Customer Service Management': 'CIS-CSM',
  'Certified Implementation Specialist - Data Foundations (CMDB and CSDM)': 'CIS-DF',
  'Certified Implementation Specialist - Discovery': 'CIS-DISCO',
  'Certified Implementation Specialist - Event Management': 'CIS-EM',
  'Certified Implementation Specialist - Field Service Management': 'CIS-FSM',
  'Certified Implementation Specialist - Hardware Asset Management': 'CIS-HAM',
  'Certified Implementation Specialist - Human Resources': 'CIS-HR',
  'Certified Implementation Specialist - IT Service Management': 'CIS-ITSM',
  'Certified Implementation Specialist - Platform Analytics': 'CIS-PA',
  'Certified Implementation Specialist - Risk and Compliance': 'CIS-RC',
  'Certified Implementation Specialist - Software Asset Management': 'CIS-SAM',
  'Certified Implementation Specialist - Security Incident Response': 'CIS-SIR',
  'Certified Implementation Specialist - Service Mapping': 'CIS-SM',
  'Certified Implementation Specialist - Service Provider': 'CIS-SP',
  'Certified Implementation Specialist - Strategic Portfolio Management': 'CIS-SPM',
  'Certified Implementation Specialist - Third Party Risk Management': 'CIS-TPRM',
  'Certified Implementation Specialist - Vulnerability Response': 'CIS-VR',
  'Certified Master Architect': 'CMA',
  'Certified Technical Architect': 'CTA',
  'Accounts Payable Operations': 'APO',
  'CSM Pro': 'CSM Pro',
  'Data Foundations (CMDB and CSDM) Pro': 'DF Pro',
  'FSO Banking and Wealth Management Pro': 'FSO-BWM Pro',
  'FSO Insurance Pro': 'FSO-Ins Pro',
  'HAM with Telecommunications Network Inventory Pro': 'HAM & TNI Pro',
  'Healthcare and Life Sciences Management Pro': 'HLSM Pro',
  'HR Pro': 'HR Pro',
  'ITSM Pro': 'ITSM Pro',
  'Public Sector Digital Services Pro': 'PSDS Pro',
  'Sourcing and Procurement Operations Pro': 'SPO Pro',
  'Supplier Lifecycle Operations Pro': 'SLO Pro',
  'Technology Provider Service Management Pro': 'TPSM Pro',
  'Telecommunications, Media, and Technology Service Management Pro': 'TMTSM Pro',
  'Workflow Data Fabric Pro': 'WDF Pro',
  'Now Assist for CSM Pro Plus': 'NowAssist CSM Pro+',
  'Now Assist for HR Pro Plus': 'NowAssist HR Pro+',
  'Now Assist for IT Service Management Pro Plus': 'NowAssist ITSM Pro+'
};

// Helper function to get acronym
export const getCertificationAcronym = (fullName) => {
  return CERTIFICATION_ACRONYMS[fullName] || fullName;
};
